(function () {
  var PANEL = document.getElementById('WhyUsMegaMenu');
  var HEADER = document.getElementById('SiteHeader');
  if (!PANEL || !HEADER) return;

  var OPEN_CLASS = 'whyus-mega--open';
  var CLOSE_DELAY = 200;
  var triggerText = (PANEL.getAttribute('data-trigger-text') || 'why us').replace(/\s+/g, ' ').trim().toLowerCase();

  var closeTimer = null;

  function findTrigger() {
    var candidates = HEADER.querySelectorAll('.site-nav__link');
    for (var i = 0; i < candidates.length; i++) {
      var text = candidates[i].textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text === triggerText) return candidates[i];
    }
    return null;
  }

  var trigger = findTrigger();
  if (!trigger) return;

  // If this navbar item still carries its own native dropdown/megamenu
  // (e.g. it hasn't been stripped of sub-links in Shopify Navigation yet),
  // stop that dropdown from also opening on hover and hide its panel so
  // only this custom mega menu shows for this one item.
  var nativeDetails = trigger.closest('details.site-nav__details');
  if (nativeDetails) {
    nativeDetails.removeAttribute('data-hover');
    nativeDetails.removeAttribute('open');
    var nativeDropdown = nativeDetails.querySelector(':scope > .site-nav__dropdown');
    if (nativeDropdown) nativeDropdown.style.display = 'none';
  }

  trigger.setAttribute('aria-haspopup', 'true');
  trigger.setAttribute('aria-expanded', 'false');

  function positionPanel() {
    // Always measure the real header element (#SiteHeader), never the
    // .header-sticky-wrapper placeholder. Once the user scrolls past the
    // floating-pill threshold, header-floating-pill.js switches #SiteHeader
    // to position:fixed while .header-sticky-wrapper stays in normal flow
    // as an empty placeholder box — so its rect scrolls out of view and
    // yields a large negative "bottom", pinning this panel to the top of
    // the page (or clipping it) instead of tracking the floating header.
    // #SiteHeader's own rect is correct in both the static and floating
    // states, so it's the only reliable anchor.
    var rect = HEADER.getBoundingClientRect();
    PANEL.style.top = Math.round(rect.bottom) + 'px';
  }

  function openPanel() {
    clearTimeout(closeTimer);
    positionPanel();
    PANEL.classList.add(OPEN_CLASS);
    PANEL.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    // Re-measure a frame later in case a scroll-triggered floating-pill
    // class toggle lands in the same tick as this hover/focus open.
    window.requestAnimationFrame(positionPanel);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      PANEL.classList.remove(OPEN_CLASS);
      PANEL.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }, CLOSE_DELAY);
  }

  trigger.addEventListener('mouseenter', openPanel);
  trigger.addEventListener('mouseleave', scheduleClose);
  trigger.addEventListener('focus', openPanel);
  trigger.addEventListener('blur', scheduleClose);

  PANEL.addEventListener('mouseenter', function () {
    clearTimeout(closeTimer);
  });
  PANEL.addEventListener('mouseleave', scheduleClose);
  PANEL.addEventListener('focusin', function () {
    clearTimeout(closeTimer);
  });
  PANEL.addEventListener('focusout', scheduleClose);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      clearTimeout(closeTimer);
      PANEL.classList.remove(OPEN_CLASS);
      PANEL.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      if (PANEL.classList.contains(OPEN_CLASS)) positionPanel();
    },
    { passive: true }
  );
  window.addEventListener('resize', function () {
    if (PANEL.classList.contains(OPEN_CLASS)) positionPanel();
  });
})();
